export default __webpack_public_path__ + "img/most.9dae7474.svg";